/**
 * CNP (Cod Numeric Personal) - Romanian Personal Identification Number
 * Validation and data extraction utilities
 */

export interface Judet {
  id_judet: number;
  id_cod: number;
  denumire: string;
  id_localitate?: number;
}

export interface CNPDetails {
  sex: number; // 0 = female, 1 = male
  JudetNastereCNP: string;
  JudetNastereRenv?: Judet;
  dateNastere: Date;
  id_judet?: number; // Foreign key to judete table
  isCnpNou: boolean; // true when county code = 70
}

const judete: Judet[] = [
  {id_judet: 1, id_cod: 1, denumire: "Alba"},
  {id_judet: 2, id_cod: 2, denumire: "Arad"},
  {id_judet: 3, id_cod: 3, denumire: "Arges"},
  {id_judet: 4, id_cod: 4, denumire: "Bacau"},
  {id_judet: 5, id_cod: 5, denumire: "Bihor"},
  {id_judet: 6, id_cod: 6, denumire: "Bistrita-Nasaud"},
  {id_judet: 7, id_cod: 7, denumire: "Botosani"},
  {id_judet: 8, id_cod: 8, denumire: "Brasov"},
  {id_judet: 9, id_cod: 9, denumire: "Braila"},
  {id_judet: 10, id_cod: 10, denumire: "Buzau"},
  {id_judet: 11, id_cod: 11, denumire: "Caras-Severin"},
  {id_judet: 12, id_cod: 12, denumire: "Cluj"},
  {id_judet: 13, id_cod: 13, denumire: "Constanta"},
  {id_judet: 14, id_cod: 14, denumire: "Covasna"},
  {id_judet: 15, id_cod: 15, denumire: "Dimbovita"},
  {id_judet: 16, id_cod: 16, denumire: "Dolj"},
  {id_judet: 17, id_cod: 17, denumire: "Galati"},
  {id_judet: 18, id_cod: 18, denumire: "Gorj"},
  {id_judet: 19, id_cod: 19, denumire: "Harghita"},
  {id_judet: 20, id_cod: 20, denumire: "Hunedoara"},
  {id_judet: 21, id_cod: 21, denumire: "Ialomita"},
  {id_judet: 22, id_cod: 22, denumire: "Iasi"},
  {id_judet: 24, id_cod: 24, denumire: "Maramures"},
  {id_judet: 25, id_cod: 25, denumire: "Mehedinti"},
  {id_judet: 26, id_cod: 26, denumire: "Mures"},
  {id_judet: 27, id_cod: 27, denumire: "Neamt"},
  {id_judet: 28, id_cod: 28, denumire: "Olt"},
  {id_judet: 29, id_cod: 29, denumire: "Prahova"},
  {id_judet: 30, id_cod: 30, denumire: "Satu-Mare"},
  {id_judet: 31, id_cod: 31, denumire: "Salaj"},
  {id_judet: 32, id_cod: 32, denumire: "Sibiu"},
  {id_judet: 33, id_cod: 33, denumire: "Suceava"},
  {id_judet: 34, id_cod: 34, denumire: "Teleorman"},
  {id_judet: 35, id_cod: 35, denumire: "Timis"},
  {id_judet: 36, id_cod: 36, denumire: "Tulcea"},
  {id_judet: 37, id_cod: 37, denumire: "Vaslui"},
  {id_judet: 38, id_cod: 38, denumire: "Valcea"},
  {id_judet: 39, id_cod: 39, denumire: "Vrancea"},
  {id_judet: 40, id_cod: 40, denumire: "Bucuresti"},
  {id_judet: 51, id_cod: 51, denumire: "Calarasi"},
  {id_judet: 52, id_cod: 52, denumire: "Giurgiu"},
  {id_judet: 59, id_cod: 23, denumire: "Ilfov"},
  {id_judet: 40, id_cod: 41, denumire: "Bucuresti - Sector 1", id_localitate: 13119},
  {id_judet: 40, id_cod: 42, denumire: "Bucuresti - Sector 2", id_localitate: 13546},
  {id_judet: 40, id_cod: 43, denumire: "Bucuresti - Sector 3", id_localitate: 13547},
  {id_judet: 40, id_cod: 44, denumire: "Bucuresti - Sector 4", id_localitate: 13548},
  {id_judet: 40, id_cod: 45, denumire: "Bucuresti - Sector 5", id_localitate: 13549},
  {id_judet: 40, id_cod: 46, denumire: "Bucuresti - Sector 6", id_localitate: 13554},
  {id_judet: 59, id_cod: 47, denumire: "Ilfov"},
  {id_judet: 70, id_cod: 70, denumire: "CNP_NOU"},
  {id_judet: 80, id_cod: 80, denumire: "Strainatate"},
  {id_judet: 81, id_cod: 81, denumire: "Strainatate"},
  {id_judet: 82, id_cod: 82, denumire: "Strainatate"},
  {id_judet: 83, id_cod: 83, denumire: "Strainatate"},
  {id_judet: 84, id_cod: 84, denumire: "Strainatate"},
  {id_judet: 85, id_cod: 85, denumire: "Strainatate"},
  {id_judet: 86, id_cod: 86, denumire: "Strainatate"},
  {id_judet: 87, id_cod: 87, denumire: "Strainatate"},
  {id_judet: 88, id_cod: 88, denumire: "Strainatate"},
  {id_judet: 89, id_cod: 89, denumire: "Strainatate"},
  {id_judet: 90, id_cod: 90, denumire: "Strainatate"},
  {id_judet: 91, id_cod: 91, denumire: "Strainatate"},
  {id_judet: 92, id_cod: 92, denumire: "Strainatate"},
  {id_judet: 93, id_cod: 93, denumire: "Strainatate"},
  {id_judet: 94, id_cod: 94, denumire: "Strainatate"},
  {id_judet: 95, id_cod: 95, denumire: "Strainatate"},
  {id_judet: 96, id_cod: 96, denumire: "Strainatate"},
  {id_judet: 97, id_cod: 97, denumire: "Strainatate"},
  {id_judet: 98, id_cod: 98, denumire: "Strainatate"},
  {id_judet: 99, id_cod: 99, denumire: "Strainatate"},
];

/**
 * Validates a Romanian CNP (Cod Numeric Personal)
 * @param value The CNP to validate
 * @returns true if valid, false otherwise
 */
export const isValidCNP = (value: string): boolean => {
  const re = /^\d{1}\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])(0[1-9]|[1-4]\d|5[0-2]|70|99|80|81|82|83|84|85|86|87|88|89|90|91|92|93|94|95|96|97|98)\d{4}$/;
  const control = '279146358279';

  if (!re.test(value)) {
    return false;
  }

  let bigSum = 0;
  for (let i = 0; i < 12; i++) {
    bigSum += parseInt(value[i], 10) * parseInt(control[i], 10);
  }

  let ctrlDigit = bigSum % 11;
  if (ctrlDigit === 10) {
    ctrlDigit = 1;
  }

  if (ctrlDigit !== parseInt(value[12], 10)) {
    return false;
  }

  return true;
};

/**
 * Extracts details (gender, birth date, county) from a valid CNP
 * @param cnp The CNP to parse
 * @returns CNPDetails object or null if invalid
 */
export const getDetaliiFromCNP = (cnp: string): CNPDetails | null => {
  if (!isValidCNP(cnp)) {
    return null;
  }

  const re = /^(\d{1})(\d{2})(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])(0[1-9]|[1-4]\d|5[0-2]|70|99|80|81|82|83|84|85|86|87|88|89|90|91|92|93|94|95|96|97|98)\d{4}$/;
  const result = re.exec(cnp);

  if (result === null) {
    return null;
  }

  const sexDigit = result[1];
  const yearTwoDigits = result[2];
  const month = result[3];
  const day = result[4];
  const countyCode = result[5];

  // Find county by code
  const judetNastere = judete.find((j) => j.id_cod === parseInt(countyCode, 10));

  // Determine sex and century
  let sex: number;
  let century: number;
  const startsWith = cnp.substring(0, 2);

  switch (sexDigit) {
    case "1":
      sex = 1; // male
      century = 1900;
      break;
    case "2":
      sex = 0; // female
      century = 1900;
      break;
    case "3":
      sex = 1;
      century = 1800;
      break;
    case "4":
      sex = 0;
      century = 1800;
      break;
    case "5":
      sex = 1;
      century = 2000;
      break;
    case "6":
      sex = 0;
      century = 2000;
      break;
    case "7":
      sex = 1;
      // Special handling for residents born in 2000s
      if (startsWith === '70' || startsWith === '71' || startsWith === '72' || startsWith === '73') {
        century = 2000;
      } else {
        century = 1900;
      }
      break;
    case "8":
      sex = 0;
      // Special handling for residents born in 2000s
      if (startsWith === '80' || startsWith === '81' || startsWith === '82' || startsWith === '83') {
        century = 2000;
      } else {
        century = 1900;
      }
      break;
    default:
      sex = 0;
      century = 1900;
  }

  const fullYear = century + parseInt(yearTwoDigits, 10);

  // Create date object (months are 0-indexed in JavaScript Date)
  const dataNastere = new Date(fullYear, parseInt(month, 10) - 1, parseInt(day, 10));

  return {
    sex,
    JudetNastereCNP: countyCode,
    JudetNastereRenv: judetNastere,
    dateNastere: dataNastere,
    id_judet: judetNastere?.id_judet,
    isCnpNou: parseInt(countyCode, 10) === 70
  };
};

/**
 * Formats a Date object to YYYY-MM-DD format for HTML date inputs
 * @param date The date to format
 * @returns Date string in YYYY-MM-DD format
 */
export const formatDateForInput = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};
